export default {
  id: 40,
  title: 'Target #40 - Letter B',
  url: 'https://cssbattle.dev/play/40',
  colors: ['#6592CF', '#243D83'],
  solution:
    '<a a><a b><style>body{background:#6592CF}a{position:fixed}a[a],a[b]{top:50;left:100}a[a]{width:100;height:100;border:50px solid #243D83;border-radius:50%}a[b]{background:#243D83;width:50;height:100;box-shadow:50px 0 #6592CF}</style>',
}
